import * as React from "react";
const SvgFiRrDurationAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-duration-alt_svg__a)">
      <path
        fill="#062147"
        d="M17.776 21.334A4.01 4.01 0 0 1 13.996 24h-9.99c-1.17 0-2.28-.51-3.045-1.398a3.94 3.94 0 0 1-.917-3.158C.45 16.746 1.93 14.246 4.445 12 1.93 9.754.45 7.254.045 4.556A3.94 3.94 0 0 1 .96 1.399 4.01 4.01 0 0 1 4.005 0h9.99a4.01 4.01 0 0 1 3.781 2.666.999.999 0 1 1-1.884.668A2.01 2.01 0 0 0 13.996 2h-9.99c-.588 0-1.146.257-1.529.703a1.91 1.91 0 0 0-.454 1.555c.375 2.499 1.922 4.84 4.598 6.958a1 1 0 0 1 0 1.568c-2.676 2.118-4.223 4.458-4.598 6.957a1.92 1.92 0 0 0 .454 1.556c.384.446.941.703 1.528.703h9.99c.852 0 1.613-.536 1.896-1.333a.998.998 0 1 1 1.884.668zm-8.15-7.39.508.405c1.172.932 2.727 2.431 3.474 4.275A1 1 0 0 1 12.681 20H5.32a1.002 1.002 0 0 1-.928-1.374c.746-1.853 2.3-3.346 3.472-4.273l.52-.411a1 1 0 0 1 1.243.002M9 16.004c-.63.509-1.37 1.194-1.965 1.996h3.928c-.594-.798-1.332-1.484-1.963-1.996M24 12.001c0 3.309-2.69 6-6 6s-6-2.691-6-6 2.691-6 6-6 6 2.691 6 6m-2 0c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4 4-1.794 4-4m-3-.414v-1.586a1 1 0 1 0-2 0v2c0 .265.105.52.293.707l1 1a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-duration-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDurationAlt;
